import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterFederativeEntities,
  reportFilterFederativeEntitySelector,
  reportFilterCountryCodeSelector,
  reportFilterStoresSelector,
} from '../../../state';
import { FederativeEntitySelect, SimpleSelectProps } from '../../selects';

type FederativeEntityFilterProps = Pick<SimpleSelectProps, 'fullWidth' | 'disabled'>;

const FederativeEntityFilter = (props: FederativeEntityFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const countryCode = useSelector(reportFilterCountryCodeSelector);
  const federativeEntities = useSelector(reportFilterFederativeEntitySelector);
  const storesSelected = useSelector(reportFilterStoresSelector);
  const isStoresSelected = storesSelected.length > 0;

  const handleChange = useCallback(
    (value: string[]) => dispatch(changeFilterFederativeEntities(value)),
    [dispatch]
  );

  return (
    <FederativeEntitySelect
      {...props}
      disabled={isStoresSelected}
      label={t('toolbar.labels.federativeEntity')}
      value={federativeEntities}
      onChange={handleChange}
      selectAll
      countryCode={countryCode}
    />
  );
};

export default FederativeEntityFilter;
